import { QuantitySelectorUI } from "./QuantitySelectorUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function QuantitySelector({ product }: Pick<StandardProps, "product">) {
  const { variant, isSelected } = useVariant(product);

  const activeVariant = ensureIsActiveVariant(variant);
  if (!activeVariant) return null;

  const { availableToOrder } = activeVariant.availability;
  if (!availableToOrder) return null;

  return <QuantitySelectorUI disabled={!isSelected} />;
}
